export default __webpack_public_path__ + "static/media/483.a01829cf.gif";